import URLS from "../../constants/urls";
import API from "../config/bookitConfig";
import ECOMM from "../config/ecommConfig";
import POS from "../config/posConfig";
import { toISO,TestFunction} from '../../../shared/utils/time';
import axios from "axios";
import moment from 'moment-timezone';


const dayToBlockTimesFor = new Date();

/**
 * get accesstoken from refresh token
 * @param {Object} data data object with refresh token
 */
export const _getRetailerAuthToken = async (data) => {
  const response = await POS.post(URLS.GET_ACCESS_TOKEN, data);
  return response;
};

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
const timezones  =()=> window.default_store_timezone;
const time_zones = timezones();

/**
 * get ecomm authentication token
 * @param {String} schema schema name
 */
/*global ECOMM_CLIENT_ID,ECOMM_CLIENT_SECRET */
/*eslint no-undef: "error"*/
export const _getEcommAuthToken = async (schema) => {
  const response = await ECOMM.post(
    `${schema}${URLS.ECOMM_AUTHENTICATE}client_id=${ECOMM_CLIENT_ID}&client_secret=${ECOMM_CLIENT_SECRET}&grant_type=client_credentials`
  );
  return response;
};

/**
 * get customer list
 * @param {String} schema schema name (not used in URL, handled by header)
 * @param {String} name customer first name
 */
/*global API_VERSION*/
/*eslint no-undef: "error"*/
export const _getCustomerList = async (schema, name) => {
  const response = await POS.get(
    `${URLS.GET_CUSTOMER_AUTO_COMPLETE}?keyword=${name}`
  );
  return response;
};

/**
 * get customer details
 * @param {String} schema schema name
 * @param {Number} id customer id
 */
/*eslint no-undef: "error"*/
// export const _getCustomerType = async(schema, input) =>{
//   const response = await ECOMM.get(
//     `/common/customer-type-autocomplete/?q=${input}`
//   )
// }
export const _getCustomerDetails = async (schema, id) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}customer/${id}/detail/`
  );
  return response;
};

/**
 * get ecomm authentication token
 * @param {String} schema schema name
 * @param {String} search search by store name
 */
export const _getEtailStoreList = async (schema, search) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_STORES_LIST}?name=${search}`
  );
  return response;
};

/**
 * get ecomm authentication token
 * @param {String} schema schema name
 * @param {Number} storeId store id
 */
export const _getEtailStoreDetails = async (schema, storeId) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_STORES_LIST}${storeId}/`
  );
  return response;
};

/**
 * get logged in user information
 *  @param {String} schema schema name
 * @param {String} userId user id
 */
export const _getUserInformation = async (schema, userId) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_LOGGED_IN_USER_INFO}?session_key=${userId}`
  );
  return response;
};

/**
 * get retailer information
 * @param {String} schema schema name
 */
export const _getRetailerInformation = async (schema) => {
  
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_RETAILER_INFO}`
  );
  return response;
};

/**
 * get services list api
 * @param {String} page
 */
export const _getServiceTypesList = async (page, pageSize, searchQuery) => {
  const response = await API.get(
    URLS.GET_SERVICE_TYPES_LIST + `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

/**
 * add new service type
 * @param {Object} data  data object
 */
export const _addNewServiceType = async (data) => {
  const response = await API.post(URLS.ADD_NEW_SERVICE_TYPE, data);
  return response;
};

// new slot creation BKI-1232
export const _createSlot = async (data) => {
  const response = await API.post(URLS.ADD_NEW_SLOT+ `?tz=${timezones()}`, data);
  return response;
};

/**
 * edit service type by id
 * @param {Number} id service id
 * @param {Object} data data object
 */
export const _editServiceType = async (id, data) => {
  const response = await API.put(`${URLS.EDIT_SERVICE_TYPE}${id}`, data);
  return response;
};

/**
 * delete service by id
 * @param {Number} id service id
 */
export const _deleteServiceType = async (id) => {
  const response = await API.delete(`${URLS.DELETE_SERVICE_TYPE}${id}`);
  return response;
};

export const _getShampooList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_SHAMPOO_LIST + `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

export const _addShampoo = async (data) => {
  const response = await API.post(URLS.ADD_SHAMPOO, data);
  return response;
};

export const _editShampoo = async (id, data) => {
  const response = await API.put(`${URLS.EDIT_SHAMPOO}${id}`, data);
  return response;
};

export const _bulkUpdateShampoo = async (data) => {
  const response = await API.put(URLS.BULK_UPDATE_SHAMPOO, data);
  return response;
};

export const _deleteShampoo = async (id) => {
  const response = await API.delete(`${URLS.DELETE_SHAMPOO}${id}`);
  return response;
};

export const _getCologneList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_COLOGNE_LIST + `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

export const _addCologne = async (data) => {
  const response = await API.post(URLS.ADD_COLOGNE, data);
  return response;
};

export const _editCologne = async (id, data) => {
  const response = await API.put(`${URLS.EDIT_COLOGNE}${id}`, data);
  return response;
};

export const _bulkUpdateCologne = async (data) => {
  const response = await API.put(URLS.BULK_UPDATE_COLOGNE, data);
  return response;
};

export const _deleteCologne = async (id) => {
  const response = await API.delete(`${URLS.DELETE_COLOGNE}${id}`);
  return response;
};

export const _getFeedingInfo = async (page) => {
  const response = await API.get(URLS.GET_FEEDING_INFO + page);
  return response;
};

export const _updateFeedingInfo = async (data) => {
  const response = await API.put(URLS.UPDATE_FEEDING_INFO, data);
  return response;
};

export const _getAttendantList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_ATTENDANT_LIST +
      `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

export const _getAllAttendantList = async (page, pageSize,search='') => {
  const response = await API.get(
    URLS.GET_ATTENDANT_LIST +
      `?pageNo=${page}&pageSize=${pageSize}&search=${search}`
  );
  return response;
};

export const _addNewAttendant = async (data) => {
  const response = await API.post(URLS.ADD_NEW_ATTENDANT, data);
  return response;
};

export const _getAttendantDetails = async (id) => {
  const response = await API.get(URLS.GET_ATTENDANT_DETAILS + id);
  return response;
};

export const _editAttendant = async (params, id) => {
  const response = await API.put(URLS.EDIT_ATTENDANT_DETAILS + id, params);
  return response;
};
/**
 * get active service types list
 */
export const _getActiveServiceTypesList = async (page, pageSize,search = '') => {
  const response = await API.get(URLS.GET_ACTIVE_SERVICE_TYPES_LIST + + `?pageNo=${page}&pageSize=${pageSize}&search=${search}`);
  return response;
};    

/**
 * get pet sizes list
 */
export const _getPetSizesList = async (petId) => {
  const response = await API.get(URLS.GET_PET_TYPES + `${petId}/sizes`);
  return response;
};

/**
 * add new pet size
 * @param {Object} data data object
 */
export const _editPetSize = async (id, data) => {
  const response = await API.put(URLS.EDIT_PET_TYPE + id,  data);
  return response;
};

/**
 * get service names by service type id
 * @param {Number} id service type id
 */
export const _getServiceNamesList = async (id) => {
  const response = await API.get(`${URLS.GET_SERVICE_NAMES_BY_ID}${id}`);
  return response;
};

/**
 * get active shampoo list
 */
export const _getActiveShampooList = async () => {
  const response = await API.get(URLS.GET_ACTIVE_SHAMPOO_LIST);
  return response;
};


export const _getAttendantByVenue = async(value, serviceId) => {
  const response = await API.get(`/attendant/${value}/${serviceId}/getAttendantByVenue`);
  return response;


}
/**
 * get add_on services list
 * @param {Number} page page number
 */
export const _getAddOnServicesList = async (page, pageSize,search = '') => {
  const response = await API.get(
    URLS.GET_ADD_ON_SERVICES_LIST + `?pageNo=${page}&pageSize=${pageSize}&search=${search}`
  );
  return response;
};

export const _getActiveAddOnServicesList = async (page) => {
  const response = await API.get(URLS.GET_ACTIVE_ADD_ON_SERVICES_LIST + page);
  return response;
};

/**
 * add new add_on service
 * @param {Object} data data object
 */
export const _addNewAddOnService = async (data) => {
  const response = await API.post(URLS.ADD_NEW_ADD_ON_SERVICE, data);
  return response;
};

/**
 * delete add on service
 * @param {Number} id add on service id
 */
export const _deleteAddOnService = async (id) => {
  const response = await API.delete(URLS.DELETE_ADD_ON_SERVICE + id);
  return response;
};

/**
 * edit add on service
 * @param {Number} id add on service id
 * @param {Object} data data object
 */
export const _editAddOnService = async (id, data) => {
  const response = await API.put(URLS.UPDATE_ADD_ON_SERVICE + id, data);
  return response;
};

/**
 * get extended behavior informations
 */
export const _getExtendedBehaviorInformation = async () => {
  const response = await API.get(URLS.GET_EXTENDED_BEHAVIOR_INFORMATION);
  return response;
};

/**
 * update extended behavior information
 * @param {Object} data data object
 */
export const _editExtendedBehaviorInformation = async (data) => {
  const response = await API.put(
    URLS.UPDATE_EXTENDED_BEHAVIOR_INFORMATION,
    data
  );
  return response;
};

/**
 * get active pet types list
 */
export const _getActivePetTypesList = async (page, pageSize) => {
  const response = await API.get(
    URLS.GET_ACTIVE_PET_TYPES + `?pageNo=${page}&pageSize=${pageSize}`
  );
  return response;
};

/**
 * get pet types list
 * @param {String} page page param
 */
export const _getPetTypesList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_PET_TYPES + `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

/**
 * add new pet type
 * @param {Formdata} data data
 */
export const _addNewPetType = async (data) => {
  const response = await API.post(URLS.ADD_NEW_PET_TYPE, data);
  return response;
};

/**
 * delete a pet type
 * @param {Number} id pet type id
 */
export const _deletePetType = async (id) => {
  const response = await API.delete(URLS.GET_PET_TYPES + id);
  return response;
};

/**
 * get pet type info by id
 * @param {Number} id pet type id
 */
export const _getPetTypInfoByID = async (id) => {
  const response = await API.get(URLS.GET_PET_TYPES + id);
  return response;
};

export const _getPetTypeActiveInfoByID = async (id) => {
  const response = await API.get(URLS.GET_PET_TYPES + id); //to be chaged to active pet type url GET_PET_DETAILS
  return response;
};

export const _getActivePetDetails = async (id) => {
  const response = await API.get(URLS.GET_PET_DETAILS + id);
  return response;
};
/**
 * update a pet type
 * @param {Number} id pet type id
 * @param {FormData} data pet type data
 */
export const _editPetType = async (id, data = {}) => {
  const queryParams = new URLSearchParams();
  const name = data?.name;
  const active = data?.active;
  const file = data?.file;

  if (name !== undefined && name !== null && `${name}`.trim() !== "") {
    queryParams.append("name", name);
  }
  if (active !== undefined && active !== null) {
    queryParams.append("active", active);
  }

  const query = queryParams.toString();
  const url = `${URLS.GET_PET_TYPES}${id}${query ? `?${query}` : ""}`;

  let response;
  if (file) {
    const formdata = new FormData();
    formdata.append("file", file);
    response = await API.put(url, formdata);
  } else {
    response = await API.put(url);
  }
  return response;
};

/**
 * update a single pet type configuration section
 * @param {Number} id pet type id
 * @param {String} sectionKey API section path (for example: breeds, hair-lengths)
 * @param {Object} data section payload
 */
export const _editPetTypeConfigSection = async (id, sectionKey, data) => {
  const response = await API.put(`pet-types/config/${id}/${sectionKey}`, data);
  return response;
};

/**
 * get venue list
 */
export const _getVenueList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_VENUE_LIST +
      `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

/**
 * get venue list
 */
 export const _getAllVenueList = async (page, pageSize) => {
  const response = await API.get(
    URLS.GET_VENUE_LIST +
      `?pageNo=${page}&pageSize=${pageSize}`
  );
  return response;
};

/**
 * delete venue
 * @param {Number} id venue id
 */
export const _deleteVenue = async (id) => {
  const response = await API.delete(URLS.DELETE_VENUE_LIST + id);
  return response;
};

/**
 * add new venue
 * @param {Object} data data object
 */
export const _addNewVenue = async (data) => {
  const response = await API.post(URLS.ADD_VENUE, data);
  return response;
};

/**
 * venue by Id
 * @param {Number} id venue id
 */
export const _venueById = async (id) => {
  const response = await API.get(URLS.VENUE_BY_ID + id);
  return response;
};

/**
 * edit venue list
 * @param {Number} id venue id
 * @param {Object} data data object
 */
export const _editVenue = async (id, data) => {
  const response = await API.put(URLS.EDIT_VENUE + id, data);
  return response;
};

/**
 * get schedule list
 * (defaultValue = "0") Integer pageNo,
 * (defaultValue = "10") Integer pageSize,
 * (defaultValue = "id") String sortBy,
 * (value = "customer", required = false) Integer customer,
 * (value = "petType", required = false) Integer petType,
 * (value = "pet", required = false) Integer pet,
 * (value = "attendant", required = false) Integer attendant,
 * (value = "venue", required = false) Integer venue,
 * (value = "startDate",required = false) @DateTimeFormat(iso = DateTimeFormat.ISO.DATE) LocalDate startDate,
 * (value = "endDate",required = false) @DateTimeFormat(iso = DateTimeFormat.ISO.DATE) LocalDate endDate
 */
export const _getScheduleList = async (params) => {
  const response = await API.get(URLS.GET_SCHEDULE_LIST, { params });
  return response;
};
export const _getBlockScheduleListforDay = async ({ formatedDate, tz, type }) => {
  console.log(formatedDate,tz,type,"pppppppppp")
  return API.get(URLS.GET_SCHEDULE_LIST_FOR_DAY, {
    params: {
      selectedDate: formatedDate,
      tz,
      ...(type && { type })
    }
  });
};
export const _getScheduleListofWeek = async (params) => {
  const response = await API.get(URLS.GET_SCHEDULE_LIST_WEEK, { params });
  return response;
};

// get slotes list
export const _getSlotesList = async (params) => {
  const response = await API.get(URLS.GET_SLOTES_LIST, { params });
  return response;
};

export const _getSlotesListofWeek = async (params) => {
  const response = await API.get(URLS.GET_SLOTES_LIST_WEEK, { params });
  return response;
};

/**
 * get appointments list
 * @param {Number} page page number
 */
export const _getAppointmentsList = async (
  pageNo,
  pageSize,
  startDate,
  endDate
) => {
  const response = await API.get(
    URLS.GET_APPOINTMENTS_LIST +
      `?pageNo=${pageNo}&pageSize=${pageSize}`
  );
  return response;
};

/**
 * get appointments list
 * @param {Number} page page number
 */
export const _fetchAppointments = async (
  pageNo,
  pageSize,
  customerId,
  attendantId,
  venueId,
  selectedStatus,
  query,
  startDate,
  endDate,
  time_zones,
  petId,
  serviceId
) => {
  const timezones = () => window.default_store_timezone;
  const tz = timezones();
  const formattedDate = TestFunction(moment(dayToBlockTimesFor).format('YYYY-M-D'), tz);
  const response = await API.get(
    URLS.GET_APPOINTMENTS_LIST +
      `?${customerId != null ? 'customer='+customerId : ""}${attendantId != null ? '&attendant='+attendantId : ""}${venueId != null ? '&venue='+venueId : ""}${selectedStatus != "" ? '&status='+selectedStatus : ""}${query != "" ? '&search='+query : ""}${startDate != "" ? '&startDate='+startDate : '' }${endDate != "" ? '&endDate='+endDate : ''}${time_zones != "" ? '&tz='+time_zones : ""}&pet=${petId ?? ''}&service=${serviceId ?? ''}&pageNo=${pageNo ?? 0}&pageSize=${pageSize ?? 10}`
  );
 
  return response;

};

/**
 * get blocked schedule list
 * @param {Number} page page number
 */
// export const _getBlockScheduleList = async (date) => {
//   const response = await API.get(
//     URLS.GET_BLOCKED_SCHEDULE_LIST + "month=" + date
//   );
//   return response;
// };


// *blockdates api changes with startdate,enddate, and timezone
export const _getBlockScheduleList = async (startDate) => {
  const response = await API.get(
  URLS.GET_BLOCKED_SCHEDULE_LIST + `startDate=${startDate?.startDate}&endDate=${startDate?.endDate}&tz=${timezones()}`
);
return response;
};

/**
 * get schedules on a date
 * @param {String} date date string
 * @param {Number} page page number
 */
export const _getSchedulesOnDateList = async (date, page) => {
  const response = await API.get(URLS.GET_SCHEDULES_ON_DATE_LIST + date + page);
  return response;
};


// BKI-1232: GETSLOTESONDATE

export const _getSlotesOnDateList = async (slotDateTime, page) => {
  const response = await API.get(URLS.GET_SLOTES_ON_DATE_LIST + slotDateTime + page);
  return response;
};

/**
 * get schedules on a date
 * @param {String} date date string
 */
 export const _getBlockSchedulesOnDateList = async (data) => {
  const response = await API.post(URLS.GET_BLOCK_SCHEDULES_ON_DATE_LIST + `?tz=${timezones()}`, data);
  return response;
};

/**
 * create recurring block schedules on a date
 * @param {Object} data block schedule data
 */
export const _getBlockSchedulesOnDateListRecurring = async (data) => {
  const tz = timezones();
  const response = await API.post(URLS.GET_BLOCK_SCHEDULES_ON_DATE_LIST_RECURRING + `?tz=${timezones()}`, data);
  return response;
};

/**
 * get schedules on a date
 * @param {String} date date string
 */
export const _getUnBlockSchedulesOnDateList = async (date) => {
  
  const response = await API.delete(URLS.DELETE_BLOCKED_DATE_LIST + date +`?tz=${timezones()}`);
  return response;
};

/**
 * get all venue list
 * @param {String} filter filter string
 */
export const _getAllActiveVenuesList = async (filter) => {
  const response = await API.post(URLS.GET_ALL_VENUES + "search", 
     filter
  );
  return response;
};

/**
 * get all attendant list
 */
export const _getAllActiveAttendantList = async (filter) => {
  const response = await API.post(URLS.GET_ALL_ATENDANTS + "search", filter);
  return response;
};

/**
 * create a new service
 * @param {Object} data data object
 */
export const _createNewService = async (data) => {
  const response = await API.post(URLS.CREATE_NEW_SERVICE, data);
  return response;
};

/**
 * get services list
 * @param {Number} page page number
 * @param {Number} pageSize page size value
 * @param {String} searchQuery search query
 */
export const _getServicesList = async (page, pageSize, searchQuery='') => {
  const response = await API.get(
    URLS.GET_SERVICES_LIST_BY_PAGINATION +
      `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}`
  );
  return response;
};

/**
 * edit service
 * @param {Object} data data object
 */
export const _editService = async (data) => {
  const response = await API.put(URLS.EDIT_SERVICE, data);
  return response;
};

/**
 * get customer pet list
 * @param {Number} page page number
 * @param {Number} pageSize page size value
 * @param {String} searchQuery search query
 */
// export const _getPetsList = async (page, pageSize, searchQuery='', customerId) => {
//   const response = await API.get(
//     URLS.GET_CUSTOMER_PET_LIST +
//       `?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}&customer=${customerId}`
//   );
//   return response;
// };

export const _getPetsList = async (page, pageSize, searchQuery = '', customerId, serviceId) => {
  let url = '';

  if (serviceId) {
    // Use the service-based URL without pagination/search
    url = `${URLS.GET_CUSTOMER_PET_LIST_BASEDONSERVICE}?serviceId=${serviceId}&customerId=${customerId}`;
  } else {
    // Use the default paginated/searchable URL
    url = `${URLS.GET_CUSTOMER_PET_LIST}?pageNo=${page}&pageSize=${pageSize}&search=${searchQuery}&customer=${customerId}`;
  }

  const response = await API.get(url);
  return response;
};




/**
 * get all pets list
 */
export const _getAllPetsList = async () => {
  const response = await API.get(URLS.GET_ALL_CUSTOMER_PET_LIST);
  return response;
};

/**
 * get pet info by id
 * @param {Number} id pet id
 */
export const _getPetInfoById = async (id) => {
  const response = await API.get(URLS.GET_ALL_CUSTOMER_PET_LIST + id);
  return response;
};

/**
 * get active cologne list
 */
export const _getActiveCologneList = async () => {
  const response = await API.get(URLS.GET_ACTIVE_COLOGNE_LIST);
  return response;
};

/**
 * create a new appointment
 * @param {Object} data data
 */
export const _createNewAppointment = async (data) => {
  const response = await API.post(URLS.CREATE_APPOINTMENT+
    `?tz=${timezones()}`, data);
  return response;
};

/**
 * get pet list by customer id
 * @param {Number} customerId customerId
 */
export const _getPetListByCustomer = async (customerId) => {
  // deceased pets should not come at time of appointment booking
  const response = await API.get(
    URLS.GET_PET_LIST_BY_CUSTOMER + customerId + "?withoutDeceasedDate=true"
  );
  return response;
};

/**
 * Add a new pet
 * @param {FormData} data data
 */
export const _createNewPet = async (data) => {
  const response = await API.post(URLS.CUSTOMER_PET_ADD, data);
  return response;
};


export const _sendEmail = async (date) => {
  const response = await API.get(
    `${URLS.SEND_EMAIL_EXPORT}?selectedDate=${date}&tz=${timezones()}`
  );
  return response;
};
/**
 * start service
 * @param {Number} id appointmentId
 */
export const _startService = async (id, startServiceAt, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    URLS.SERVICE + id + URLS.START_SERVICE + 
    "?serviceStartAt=" + startServiceAt + 
    "&updatedCustomerId=" + createdCustomerId + 
    "&updatedCustomerName=" + createdCustomerName
  );
  return response;
};

/**
 * stop service
 * @param {Number} id appointment id
 * @param {String} data data url param
 */
 export const _stopService = async (id, data, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    `${URLS.SERVICE}${id}${URLS.END_SERVICE}?updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`,
    data
  );
  return response;
};


/**
 * get appointment details by id
 * @param {Number} id  appointment id
 */
export const _getAppointmentDetailsById = async (id) => {
  const response = await API.get(URLS.GET_APPOINTMENT_DETAILS_BY_ID + id);
  return response;
};

/**
 * get Slot details by id
 * @param {Number} id  slot id
 */

 export const _getSlotsDetailsById = async (id) => {
  // const response = await API.get(URLS.GET_SLOT_DETAILS_BY_ID + "?id=" + id);
  const timezones = () => window.default_store_timezone;
  const tz = timezones();
  const response = await API.get(`${URLS.GET_SLOT_DETAILS_BY_ID}?id=${id}&tz=${tz}`);
  return response;
};

/**
 * get payment details by id
 * @param {Number} id  payment id
 */
 export const _paymentDetails = async (id) => {
  const response = await API.post(URLS.GET_PAYMENT + id);
  return response;
};

/**
 * get customer pet list by id
 * @param { Number } id customer id
 */
export const _getCustomerPetList = async (id) => {
  const response = await API.get(URLS.GET_PET_LIST_BY_CUSTOMER + id);
  return response;
};

/**
 * get service details by id
 * @param {Number} id service id
 */
export const _getServiceDetails = async (id) => {
  const response = await API.get(URLS.SERVICE_INFO_BY_ID + id);
  return response;
};

/**
 * edit  customer pet
 * @param {Number} id pet id
 * @param {Object} data data object
 */
export const _editCustomerPet = async (id, data) => {
  const response = await API.put(URLS.CUSTOMER_PET_UPDATE + id, data);
  return response;
};
//api for view all in  schedule page
export const _getSchedulesOnDateByPagination = async (
  date,
  page,
  pageSize,
  searchQuery=''
) => {
  const response = await API.get(
    URLS.GET_SCHEDULES_ON_DATE_LIST +
      `?pageNo=${page}&pageSize=${pageSize}&date=${toISO(date)}&tz=${timezones()}${
        searchQuery != "" ? `&search=${searchQuery}` : ""
      }`
  );
  return response;
};

export const _getServiceHistoryDetails = async (id) => {
  const response = await API.get(URLS.GET_SERVICE_HISTORY_DETAILS + id);
  return response;
};

export const _getServiceHistoryNotes = async (id) => {
  const response = await API.get(URLS.GET_SERVICE_HISTORY_NOTES + id);
  return response;
};

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const _getServiceHistoryNotesList = async (id) => {
  const response = await API.get(URLS.SERVICE + id + URLS.LIST_NOTES, {
    headers: { time_zone: timezone },
  });
  return response;
};

export const _getServiceHistoryNotesByPetIdList = async (id, page, pageSize) => {
  const response = await API.get(URLS.SERVICE + URLS.LIST_NOTES_BY_PET_ID + id
      + `?pageNo=${page}&pageSize=${pageSize}`, {});
  return response;
};

export const _addServiceHistoryNotesList = async (id, data) => {
  const response = await API.post(URLS.SERVICE + id + URLS.ADD_NOTES, data);
  return response;
};


export const _editServiceHistoryNotesList = async (id, data) => {
  const response = await API.put(URLS.SERVICE + id + URLS.NOTES, data);
  return response;
};

/**
 * get service history list
 * @param {Number} page page number
 * @param {Number} pageSize page size value
 * @param {String} searchQuery search query
 * @param {Number} customerId customer Id
 */
export const _getServiceHistoryList = async (
  page,
  pageSize,
  searchQuery='',
  customerId,
  startDate,
  endDate,
  petType,
  serviceStatus,
  pet,
  service
) => {
  const response = await API.get(
    URLS.SERVICE_HISTORY +
      `?customer=${customerId}&pageNo=${page}&pageSize=${pageSize}${
        startDate != "" ? `&startDate=${startDate}` : ""
      }${endDate != "" ? `&endDate=${endDate}` : ""}` +
      `${petType != "" ? `&petType=${petType}` : ""}${
        serviceStatus != "" ? `&serviceStatus=${serviceStatus}` : ""
      }` +
      // search param can be used to search either appointmentId or pet name
      `${pet ? "&search=" + pet ?? "" : ""}${
        service ? "&service=" + service : ""
      }`
  );
  return response;
};

/**
 * edit appointment api
 * Only edits date and time
 * @param {Number} id appointment id
 * @param {String} date date string
 * @param {String} time time string
 */
export const _editAppointmentDetails = async (id, date, startTime , endTime, tz, createdCustomerId, createdCustomerName) => {
  const response = await API.put(
    `${URLS.EDIT_APPOINTMENT}?id=${id}&date=${date}&startTime=${startTime}&endTime=${endTime}&tz=${timezones()}&updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`
  );
  return response;
};


// edit the slot
export const _editSlotDetails = async (data, id , enable) => {
  // Make sure URLS.EDIT_SLOT contains the base part of your endpoint URL
  const response = await API.put(`${URLS.EDIT_SLOT}/${id}?changeEntireRecurringSlots=${enable}&tz=${timezones()}`, data);

  return response;
};



/**
 * cancel an appointment
 * @param {Number} id appointment id
 */
 export const _cancelAppointment = async (id, tz, cancellationReason, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    `${URLS.SERVICE}${id}${URLS.CANCEL_APPOINTMENT}?tz=${tz}&cancellationReason=${cancellationReason}&updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`
  );
  return response;
};


export const _rejectAppointment = async (id, tz , rejectionReason, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    `${URLS.SERVICE}${id}/changeServiceStatus?serviceStatus=REJECT&tz=${tz}&rejectionReason=${rejectionReason}&updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`
  );
  return response;
};



export const _approveAppointment = async (id, tz, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    `${URLS.SERVICE}${id}/changeServiceStatus?serviceStatus=APPROVE&tz=${tz}&updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`
  );
  return response;
};


/**
 * cancel an slot
 * @param {Number} id appointment id
 */
 export const _cancelSlot = async (id, deleteall,tz) => {
  const response = await API.delete(
    `${URLS.CANCEL_SLOT}?id=${id}&changeEntireRecurringSlots=${deleteall}`
  );
  return response;
};
/**
 * Waive service
 * @param {Number} id appointment id
 */
 export const _waiveService = async (id, createdCustomerId, createdCustomerName) => {
  const response = await API.post(
    `${URLS.SERVICE}${id}/waive?updatedCustomerId=${createdCustomerId}&updatedCustomerName=${createdCustomerName}`
  );
  return response;
};


/**
 * delete attendant
 * @param {Number} id attendant id
 */
export const _deletAttendant = async (id) => {
  const response = await API.delete(`${URLS.GET_ATTENDANT_DETAILS}${id}`);
  return response;
};

/**
 * delete service
 * @param {Number} id service id
 */
export const _deleteService = async (id) => {
  const response = await API.delete(`${URLS.SERVICE}${id}`);
  return response;
};

/**
 * delete pet
 * @param {Number} id pet id
 */
export const _deletePet = async (id) => {
  const response = await API.delete(`${URLS.GET_ALL_CUSTOMER_PET_LIST}${id}`);
  return response;
};

/**
 * get active services list
 */
export const _getActiveServices = async () => {
  const response = await API.get(URLS.GET_ACTIVE_SERVICES);
  return response;
};

/**
 * Get (id, name) of all the services
 */
export const _getAllServices = async () => {
  const response = await API.get(URLS.SERVICE);
  return response;
};

/**
 * get appointment cost
 * @param {Object} data appointment params
 */
export const _getServiceAmount = async (data) => {
  const response = await API.post(URLS.GET_SERVICE_AMOUNT+ `?tz=${timezones()}`, data);
  return response;
};

/**
 * get appointment available timeslots
 * @param {String} serviceId service id
 *  @param {String} venueId venue id
 *  @param {String} attendantId attendant id
 *  @param {String} duration duration id
 * @param {String} date appointment date
 */
export const _getAvailableTimeSlots = async (
  serviceId,
  venueId,
  attendantId,
  duration,
  date,
  tz
) => {
  const response = await API.get(
    `${URLS.GET_AVAILABLE_TIME_SLOTS}?service=${serviceId}&venue=${venueId}
     ${duration != null ? `&duration=${duration}` : ""}&date=${date}&tz=${timezones()}`
  );
  return response;
};
//api for manual slots of the day
export const _getAvailableTimeSlotsManual = async (
  serviceId,
  venueId,
  attendantId,
  duration,
  date,
  tz
) => {
  const response = await API.get(
    `${URLS.GET_AVAILABLE_TIME_SLOTS_MANUAL}?service=${serviceId}&venue=${venueId}&date=${date}&tz=${timezones()}`
  );
  return response;
};
/**
 * get time zone list
 * @param {String} schema schema name
 */
export const _getTimeZoneList = async (schema) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_STORES_LIST}`
  );
  return response;
};
/**
 * set time zone
 * @param {String} schema schema name
 * @param {Number} id store id
 */
export const _setTimeZoneList = async (schema, id) => {
  const response = await ECOMM.post(
    `${schema}/${API_VERSION}${URLS.ADD_TIME_ZONE}?store_id=${id}`
  );
  return response;
};
/**
 * get customer list by searching name
 * @param {String} schema schema name (not used in URL, handled by header)
 * @param {String} name customer first name
 * @param {Number} page page number (not used in new API)
 */
export const _getCustomerListByNameSearch = async (schema, name, page=1) => {
  const response = await POS.get(
    `${URLS.GET_CUSTOMER_AUTO_COMPLETE}?keyword=${name}`
  );
  return response;
};
/**
 * get store list by searching name
 * @param {String} schema schema name
 *  @param {String} name store name
 */
export const _getStoreListByNameSearch = async (schema, name) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}${URLS.GET_STORES_LIST}?name=${name}`
  );
  return response;
};
/**
 * get customer list by searching name
 * @param {String} schema schema name
 * @param {String} customerId customer id
 * @param {String} searchLine customer address line1
 */
export const _getCustomerAddressById = async (
  schema,
  customerId,
  searchLine
) => {
  const response = await ECOMM.get(
    `${schema}/${API_VERSION}customer/${customerId}${URLS.GET_CUSTOMER_ADDRESS_LIST}?query=${searchLine}`
  );
  return response;
};

/* Document Service Type Section API */
export const _getAllDocs = async (page, pageSize) => {
  const url = URLS.CONFIG_DOC + `?pageNo=${page}&pageSize=${pageSize}`
  const response = await API.get(url);
  return response;
};

export const _updateConfigDocById = async (id, data) => {
  const response = await API.put(`${URLS.CONFIG_DOC}${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response;
}

export const _deleteConfigDocById = async (id) => {
  const response = await API.delete(`${URLS.CONFIG_DOC}${id}`);
  return response;
}
// _addNewConfigDoc

export const _addNewConfigDoc = async data => {
  const response = await API.post(`${URLS.CONFIG_DOC}`, data);
  return response
}

export const _addtoWaitList = async data => {
  const response = await API.post(`${URLS.ADD_TO_WAITLIST}`, data);
  return response
}

// In shared/httpService/apis.js or top of your component file
export const _fetchWaitlistSlots = async (page , pageSize) => {
  // Replace with your actual backend URL in production
  const url = URLS.FETCH_WAITLIST + `?pageNo=${page}&pageSize=${pageSize}`
  const response = await API.get(url)
  return response;
};




export const _getWaitlistedCustomers = async (timeSlotId) => {
 
  const response = await API.get(`${URLS.WAITLISTED_CUSTOMERS}/${timeSlotId?.timeSlotId}`);
  return response;
};
export const _updateWaitListBulk = async (data) => {
  const response = await API.put(`${URLS.UPDATE_WAITLIST}`, data);
};



export const _getAllActiveDocs = async () => {
  const response = await API.get(`${URLS.CONFIG_DOC}active`);
  return response;
}
/**
 *
 * get waiver of liability configuration for retailer
 */
export const _getWaiverOfLiabilityConfigurationInfo = async () => {
  const response = await API.get(URLS.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO);
  return response;
};

// @TODO move strings to constants
/**
 * update waiver of liability configuration of a retailer
 * @param data updated waiver of liability
 */
export const _updateWaiverOfLiabilityConfigurationInfo = async (data) => {
  const response = await API.put(URLS.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response;
};

/**
 * Get detailed list of all appointments on one day
 * @param dateStr date string in format YYYYMMDD
 */

export const _getAllAppointmentsByDay = async (dateStr) => {
  const response = await API.get(`/appointment/printAppointments?date=${dateStr}&tz=${timezones()}`)
  return response
}

/**
 * returns service documents 
 * @param {string} customerId customer id
 * @returns service documents of given customer id
 */
export const _getServiceDocuments = async (customerId) => {
  const response = await API.get(`appointment/get-all-uploaded-appointment-documents-by-customer-id/${customerId}`)
  return response
}

/**
 * Get Signed PDf URL
 * 
 * @param {string} initialName user's initials / name that need to be signed into the PDF doc
 * @param {string} SRC the source of PDF file (S3 URL)
 * @param {number} petId pet Id of currently selected pet
 * @returns response containing signed pdf url
 */
export const _getSignedWaiverPDF = async (initialName, SRC, petId) => {
  const response = await API.get(`waiver-of-liability-information/sign?initialName=${initialName}&SRC=${SRC}&petId=${petId}`)
  return response;
}


/**
 * check waiver info by pet id
 * @param {string} petId pet id
 * @returns info regarding petId whether waiver is previously signed or not
 */
export const checkWaiverInfoByPetId = async (petId) => {
  const response = await API.get("waiver-of-liability-information/getByPetId/" + petId)
  return response;
}

/**
 * check waiver info by pet id
 * @param {string} petId pet id
 * @returns info regarding petId whether waiver is previously signed or not
 */
export const checkWaiverInfoByAppointmentId = async (appointmentId) => {
  const response = await API.get("waiver-of-liability-information/getByAppointmentId/" + appointmentId)
  return response;
}

/**
 * Edits an appointment
 * Edits All appointment Details
 * @param {Object} data data
 */
 export const _updateAppointment = async (id, data) => {
  const response = await API.put(`${URLS.UPDATE_APPOINTMENT}?id=${id}&tz=${timezones()}`, data);
  return response;
};

//manualslotscheckboxapi
export const _manualSlotCheckbox = async (data) => {
  const response = await API.put(`${URLS.UPDATE_CHECKBOX}?isEnableSlot=${data}`);
  return response;
};
export const _getmanualSlotCheckbox = async () => {
  const response = await API.get(`${URLS.GET_CHECKBOX_VALUE}`);
  return response;
};

export const _createTwilioConversation = async (schema, data) => {
  const response = await ECOMM.post(`${schema}/${API_VERSION}messages/conversations/create/`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  return response;
}

export const _createTwilioToken = async (schema) => {
  const response = await ECOMM.get(`${schema}/${API_VERSION}messages/token/create/`);
  return response;
}

export const _getAvailabilitySlotsByDateRange = async (query) => {
  const response = await API.get(`appointment/available-slots-by-date-range?${query}`)
  return response;
}
export const _getAvailabilitySlotsByDateRangemanual = async (query) => {
  const response = await API.get(`timeslot/fetchSlotsByAttendantOfaMonth?${query}`)
  return response;
}

// In your services file (api.js or similar)
export const _getSpecificServiceType = async (serviceId, venueId, attendantId) => {
  const response = await API.get(`service-types/getServiceType?serviceId=${serviceId}&venueId=${venueId}&attendantId=${attendantId}`);
  return response;
};

// query: fileURL, petId, documentId, name
export const _signPetDocument = async (query) => {
  const response = await API.get(`/pet/petDocument/sign?${query}`)
  return response;
}

export const _serviceByPagination = async (query) => {
  const response = await API.get(`service/serviceByPagination${query}`)
  return response;
}

//get ShampooList By Pagination
export const _getShampooListByPagination = async (pageNo,pageSize,inputName)=>{
  const response = await API.get("pet-shampoo/getAllByActive"+`?pageNo=${pageNo}&pageSize=${pageSize}&search=${inputName}`);
  return response;
}

//get Cologne By Pagination
export const _getCologneListByPagination = async (pageNo,pageSize,inputName)=>{
  const response = await API.get("pet-cologne/getAllByActive"+`?pageNo=${pageNo}&pageSize=${pageSize}&search=${inputName}`);
  return response;
}

//get addOnService By Pagination
export const _getAddOnServiceListByPagination = async (pageNo,pageSize,inputName)=>{
  const response = await API.get("add-on-service/getAllByActive"+`?pageNo=${pageNo}&pageSize=${pageSize}&search=${inputName}`);
  return response;
}
//get VenueList By Pagination
export const _getVenueListByPagination = async (pageNo,pageSize,inputName)=>{
  const response = await API.get("venue/venuesByPagination"+`?pageNo=${pageNo}&pageSize=${pageSize}&search=${inputName}`);
  return response;
}

export const _getServiceTypeByPagination = async (pageNo,pageSize,inputName)=>{
  const response = await API.get("service-types/getAllByActive"+`?pageNo=${pageNo}&pageSize=${pageSize}&search=${inputName}`);
  return response;
}

export const _getCustomerType = async (domain_url, API, input)=>{
 
  const GETCUSTOMERTYPE = axios.create({
    baseURL:"https://"+ domain_url,
    timeout: 16000,
    // headers: {
    //   Accept: "*/*",
    //   "Content-Type": "application/json",
    // },
    withCredentials: true,
  });

  const response  = await GETCUSTOMERTYPE.get(`${API}${input}`).then(function (response) {
  
  })
}

export const _createCustomerUrl = async(URLS, data) =>{
  // eslint-disable-next-line no-undef
  const response = await POS.post(`${URLS}`,data, { baseURL: POS_API })
  return response;

}

export const _createCustomerPet = async(data, userId)=>{
  return await API.post(`/bookitCustomer/${userId}/pet/new/`,data);}
export const _getServicesByRetailers = async  (pageNo,pageSize,inputName)=>{
  const response = await API.get(`service/getServicesByRetailer/?pageSize=${pageSize}&pageNo=${pageNo}&search=${inputName}`);
  return response;
}


export const _sendEmailToCustomer = async (customerId,petId) => {
  const url = `${URLS.SEND_EMAIL}`;
  const data = { customerId };

  try {
    const response = await API.get(url+`?customerId=${customerId}&petId=${petId}`);
    return response; // Return the response to the calling function
  } catch (error) {
    console.error("Error in email API:", error);
    throw error; // Throw error for handling in the calling function
  }
};

/**
 * Accept Google Calendar invite
 * @param {Number} attendantId - Attendant ID
 * @param {String} retailer - Retailer name for header
 */
export const _acceptGoogleCalendarInvite = async (attendantId, retailer) => {
  const response = await API.post(`google-calendar/accept-invite/${attendantId}`, {}, {
    headers: {
      retailer: retailer
    }
  });
  return response;
};

/**
 * Complete Google Calendar OAuth
 * @param {String} code - OAuth authorization code
 * @param {Number} attendantId - Attendant ID
 * @param {String} retailer - Retailer name for header
 */
export const _completeGoogleCalendarOAuth = async (code, attendantId, retailer) => {
  const response = await API.get(`google-calendar/complete-oauth?code=${code}&attendantId=${attendantId}`, {
    headers: {
      retailer: retailer
    }
  });
  return response;
};

/**
 * Download Excel template for bulk appointment import (GET blob).
 * @param {string} retailerName – value for Retailer header (typically tenant schema)
 */
export const _downloadAppointmentImportTemplate = async (retailerName) => {
  const response = await API.get(URLS.APPOINTMENT_IMPORT_TEMPLATE, {
    responseType: "blob",
    headers: {
      Retailer: retailerName,
    },
  });
  return response;
};

/**
 * Upload filled Excel for appointment import.
 * @param {File} file – spreadsheet file
 * @param {string} tz – IANA timezone (e.g. America/New_York)
 * @param {string} retailerName – value for Retailer header
 */
export const _uploadAppointmentImportFile = async (file, tz, retailerName) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await API.post(
    `${URLS.APPOINTMENT_IMPORT_UPLOAD}?tz=${encodeURIComponent(tz)}`,
    formData,
    {
      responseType: "blob",
      headers: {
        Retailer: retailerName,
      },
    }
  );
  return response;
};